__turbopack_context__.v({
  "aside": "Rs-BJW_aside",
  "exhibition-theme__svg-wrapper": "Rs-BJW_exhibition-theme__svg-wrapper",
  "exhibition-theme__text": "Rs-BJW_exhibition-theme__text",
  "exhibitionTheme": "Rs-BJW_exhibitionTheme",
  "main": "Rs-BJW_main",
  "shelf": "Rs-BJW_shelf",
  "sliderWrapper": "Rs-BJW_sliderWrapper",
  "subtitle": "Rs-BJW_subtitle",
  "title": "Rs-BJW_title",
});
